// 全局的状态管理常量 调用可以改变state状态

export const SHOW_NOTIFY = "SHOW_NOTIFY"; // 请求错误
export const SET_LOADING = "SET_LOADING"; // 全局请求加载动画
export const SET_TOPBARTIPS = "SET_TOPBARTIPS" // 设置顶部tips
export const SET_TOPBARPATH = "SET_TOPBARPATH" // 顶部bar